export const ItemVacio = (idPadre) => {
  return {
    id: null,
    idTorneo: idPadre,
    orden: null,
    etapa: null, // objeto parametro de tipo etapa_torneo
    definicion: false, // por defecto es etapa de grupos
    cantidadRuedas: null,
    cantidadCruces: null,
    cantidadFechas: null,
    zonas: false,
  };
};

export const saveItem = (item) => {
  return {
    idTorneo: item.idTorneo,
    orden: item.orden,
    codEtapa: item.etapa && item.etapa.codigo,
    definicion: item.definicion,
    cantidadRuedas: item.cantidadRuedas,
    cantidadCruces: item.cantidadCruces,
    cantidadFechas: item.cantidadFechas,
    zonas: item.zonas,
  };
};
